import type { PanelConstraints } from './types';

/**
 * apply width constraints
 */
export function applyWidthConstraints(width: number, constraints: PanelConstraints): number {
  let constrainedWidth = width;

  if (constrainedWidth < constraints.minWidth) {
    constrainedWidth = constraints.minWidth;
  }

  if (constraints.maxWidth && constrainedWidth > constraints.maxWidth) {
    constrainedWidth = constraints.maxWidth;
  }

  return constrainedWidth;
}

/**
 * calculate new panel width
 */
export function calculateNewWidth(
  originalWidth: number,
  deltaX: number,
  constraints: PanelConstraints
): number {
  const newWidth = originalWidth + deltaX;
  return applyWidthConstraints(newWidth, constraints);
}

/**
 * validate width config is valid
 */
export function validateWidthConfig(
  initialWidths: number[],
  minWidths?: number[],
  maxWidths?: number[]
): void {
  if (minWidths && minWidths.length !== initialWidths.length) {
    console.warn('minWidths length should match initialWidths length');
  }

  if (maxWidths && maxWidths.length !== initialWidths.length) {
    console.warn('maxWidths length should match initialWidths length');
  }

  initialWidths.forEach((width, index) => {
    const minWidth = minWidths?.[index];
    const maxWidth = maxWidths?.[index];

    if (minWidth && width < minWidth) {
      console.warn(
        `Initial width ${width} is less than minimum width ${minWidth} for panel ${index}`
      );
    }

    if (maxWidth && width > maxWidth) {
      console.warn(
        `Initial width ${width} is greater than maximum width ${maxWidth} for panel ${index}`
      );
    }
  });
}
